// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@guestsupply/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { orderConfirmationBillingInformationStyles } from "@guestsupply/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsBillingInformation";
import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderConfirmationBillingInformationStyles.divider = {
    ...mergeWithCss(xOrderInformationStyles.address?.divider, {
        className: "divider-item",
        width: 11,
        css: css`
            &&& {
                border-top: 1px solid ${getColor("common.border")};
                margin: 8px 0 12px 0;
                padding: 0;
                min-width: 100%;
            }
        `,
    }),
};
orderConfirmationBillingInformationStyles.billingInformationBillingAddressGridItem = {
    ...mergeWithCss(orderConfirmationBillingInformationStyles.billingInformationBillingAddressGridItem, {
        css: css`
            &&& {
                display: block;
                margin-bottom: 10px;
            }
        `,
    }),
    width: 12,
};
orderConfirmationBillingInformationStyles.billingInformationCreditCardAddressGridItem = {
    width: 12,
    css: css`
        display: block;
    `,
};
orderConfirmationBillingInformationStyles.billingCreditCardAddressTitle = {
    ...mergeWithCss(orderConfirmationBillingInformationStyles.billingCreditCardAddressTitle, {
        css: css`
            margin-bottom: 5px;
        `,
    }),
};
orderConfirmationBillingInformationStyles.billingAddressTitle = {
    ...orderConfirmationBillingInformationStyles.billingAddressTitle,
    css: css`
        margin-bottom: 5px;
    `,
};
